import { render, staticRenderFns } from "./EmptyTab.vue?vue&type=template&id=0bf70ef6&scoped=true"
import script from "./EmptyTab.vue?vue&type=script&lang=js"
export * from "./EmptyTab.vue?vue&type=script&lang=js"
import style0 from "./EmptyTab.vue?vue&type=style&index=0&id=0bf70ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf70ef6",
  null
  
)

export default component.exports